import { b as e, a as r, c as m, d as t } from "./variables-DpYn0Mcl.js";
var E = ((a) => (a[a.DEFAULT = parseInt(e, 10)] = "DEFAULT", a[a.MEDIUM = parseInt(r, 10)] = "MEDIUM", a[a.LARGE = parseInt(m, 10)] = "LARGE", a[a.XLARGE = parseInt(t, 10)] = "XLARGE", a))(E || {});
export {
  E as B
};
